import { useState } from 'react'
import type { PuzzleRendererProps } from '@/game/PuzzleRenderer'

type Item = { id: string; label: string }
type Config = { categories?: Item[]; items?: Item[] }

/** Tap a category chip per item. Submits { assignments: { itemId: categoryId } }. */
export function CategorizationPuzzle({ puzzle, onSubmit, disabled }: PuzzleRendererProps) {
  const { categories = [], items = [] } = puzzle.publicConfig as Config
  const [assignments, setAssignments] = useState<Record<string, string>>({})
  const complete = items.every((i) => assignments[i.id])

  return (
    <div className="puzzle-form">
      <ul className="categorize">
        {items.map((item) => (
          <li key={item.id} className="categorize-item">
            <span className="categorize-label">{item.label}</span>
            <div className="chips" role="radiogroup" aria-label={`Category for ${item.label}`}>
              {categories.map((c) => {
                const selected = assignments[item.id] === c.id
                return (
                  <button
                    key={c.id}
                    type="button"
                    role="radio"
                    aria-checked={selected}
                    className={`chip${selected ? ' selected' : ''}`}
                    disabled={disabled}
                    onClick={() => setAssignments((a) => ({ ...a, [item.id]: c.id }))}
                  >
                    {c.label}
                  </button>
                )
              })}
            </div>
          </li>
        ))}
      </ul>
      <button type="button" className="primary" disabled={disabled || !complete} onClick={() => void onSubmit({ assignments })}>
        {disabled ? 'Checking…' : 'Submit'}
      </button>
    </div>
  )
}
